<template>
    <div class="programControl">

        <div class="programControl-title">
           <h1 > 控制月娘小程序登录/注册跳转路径设置（请勿乱动）</h1><br>
           <span>注意事项：</span><br>
           <span>1、默认启用：微信一键登录弹窗逻辑:</span><br>
           <span>2、出现“微信一键登录”违规时，请尽快切换：启用手机号码登录/注册逻辑</span><br>


        <div style="margin-top: 50px;">
            状态:<el-radio style="margin-left: 30px;" v-model="radio" label="1">启用微信一键登录弹窗</el-radio>
            <el-radio v-model="radio" label="2">启用手机号码登录注册页面</el-radio>
        </div><br>
        <el-button  @click="Determine"  style="background: rebeccapurple; width: 200px; border-radius: 10px; color: #fff; margin-left: 5%;margin-top: 50px;" >确定</el-button>
        </div>
    </div>
</template>

<script>
import {getMiniAppJumpUrlSwitch,updateMiniAppJumpUrlSwitch } from '../../api/userMG'
 export default{
    data(){
        return{
            radio:"",
        }
    },
    mounted(){
   this.ongetMiniAppJumpUrlSwitch()
    },
    methods:{
        Determine(){
            updateMiniAppJumpUrlSwitch({
                type:this.radio
            }).then(res=>{
               if(res.code==0){
                this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.ongetMiniAppJumpUrlSwitch()
               }else{
                this.$message({
         type: 'warning',
         message: res.message
       })
               }
            })
        },
        ongetMiniAppJumpUrlSwitch(){
            getMiniAppJumpUrlSwitch(
                {
                    platformType:1
                }
            ).then(res=>{
                this.radio=String(res.data)
    //   console.log(res.data);
      
            })
        }
    }
 }
</script>
 
<style>
.programControl{
    width: 100%;

}
.programControl-title{
    margin-top: 100px;
    margin-left: 50px;
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/views/machine/programControl.vue